import React, { useEffect, useState } from 'react'
import {
    View,
    Dimensions,
    Image,
    Text,
    ImageBackground,
    Pressable,
} from 'react-native'
import Svg, {
    Path,
    G,
    Defs,
    RadialGradient,
    Stop,
    LinearGradient,
} from 'react-native-svg'
import { RouletteComponentTheme } from '../../../themeConstants'

const { width } = Dimensions.get('window')
const size = width
const center = size / 2
const radius = center

const GAP_ANGLE = 5 // degrees of space between segments

const degToRad = (deg: number) => (deg * Math.PI) / 180
const innerRadius = radius * 0.1 // este es el hueco central
const describeDonutSlice = (
    x: number,
    y: number,
    outerR: number,
    innerR: number,
    startAngle: number,
    endAngle: number,
) => {
    const largeArc = endAngle - startAngle <= 180 ? '0' : '1'

    const startOuter = {
        x: x + outerR * Math.cos(degToRad(startAngle)),
        y: y + outerR * Math.sin(degToRad(startAngle)),
    }
    const endOuter = {
        x: x + outerR * Math.cos(degToRad(endAngle)),
        y: y + outerR * Math.sin(degToRad(endAngle)),
    }

    const startInner = {
        x: x + innerR * Math.cos(degToRad(endAngle)),
        y: y + innerR * Math.sin(degToRad(endAngle)),
    }
    const endInner = {
        x: x + innerR * Math.cos(degToRad(startAngle)),
        y: y + innerR * Math.sin(degToRad(startAngle)),
    }

    return `
    M ${startOuter.x} ${startOuter.y}
    A ${outerR} ${outerR} 0 ${largeArc} 1 ${endOuter.x} ${endOuter.y}
    L ${startInner.x} ${startInner.y}
    A ${innerR} ${innerR} 0 ${largeArc} 0 ${endInner.x} ${endInner.y}
    Z
  `
}

export const RouletteComponent = ({
    segments,
    colors,
    returnSelectedCategory,
    prevCategory,
}) => {
    const NUM_SEGMENTS = segments.length || 0
    const anglePerSegment = 360 / NUM_SEGMENTS
    const adjustedAngle = anglePerSegment - GAP_ANGLE
    const minDelay = 20
    const maxDelay = 170
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [alreadySpinned, setAlreadySpinned] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)

    useEffect(() => {
        if (prevCategory != null) {
            setSelectedCategory(prevCategory)
            setSelectedIndex(
                segments.findIndex((segment) => segment._id === prevCategory._id),
            )
            setAlreadySpinned(true) // Set alreadySpinned to true if a previous category is provided
        } else {
            setSelectedCategory(null)
            setSelectedIndex(null)
            setAlreadySpinned(false) // Reset alreadySpinned if no previous category is provided
        }
    }, [prevCategory])
    const startSpinning = async () => {
        console.log('START PREV')
        if (alreadySpinned) {
            return
        }
        console.log('START POST')
        setAlreadySpinned(true)
        let currentIndex = 0
        const categoryCount = segments.length
        console.log('CAT COUNT ==>', categoryCount)
        const selectedCategory = Math.floor(Math.random() * categoryCount) // Choose a random category

        const completeRounds = Math.floor(Math.random() * 3 + 5) // Randomly choose between 3 and 5 complete rounds, rounded down
        const totalSpins = completeRounds * categoryCount + selectedCategory // Total spins to land on the selected category
        for (let i = 0; i <= totalSpins; i++) {
            if (currentIndex >= categoryCount - 1 || i == 0) {
                currentIndex = 0 // Reset to zero if it exceeds the number of segments
            } else {
                currentIndex = currentIndex + 1
            }
            setSelectedIndex(currentIndex)

            const time = totalSpins - i
            const currentDelay = calculateDecelerationDelay(
                totalSpins,
                time,
                minDelay,
                maxDelay,
            )

            await new Promise((resolve) => setTimeout(resolve, currentDelay))
        }
        setSelectedCategory(segments[selectedCategory]) // Set the selected category after the spins
        returnSelectedCategory(segments[selectedCategory])
        setSelectedIndex(null)
    }
    function calculateDecelerationDelay(
        totalSpin,
        currentTime,
        minDelayMs,
        maxDelayMs,
    ) {
        // Asegurarse de que totalSpin no sea 0 para evitar división por cero.
        // Si totalSpin es 0, no hay "spin" o duración, así que el retraso debería ser el máximo.
        if (totalSpin <= 0) {
            return maxDelayMs
        }

        // Asegurarse de que currentTime esté dentro del rango válido [0, totalSpin]
        currentTime = Math.max(0, Math.min(currentTime, totalSpin))

        // Calcular el factor de normalización.
        // Cuando currentTime es totalSpin, factor es 0.
        // Cuando currentTime es 0, factor es 1.
        const normalizedFactor = 1 - currentTime / totalSpin

        // Calcular el retraso utilizando la interpolación lineal invertida.
        const delay = minDelayMs + (maxDelayMs - minDelayMs) * normalizedFactor

        return delay
    }
    const viewRotation = anglePerSegment * 2
    const [rouletteState, setRouletteState] = useState(true)
    const imageOn = require('../../../assets/gamification/rouletteFrameOn.png')
    const imageOff = require('../../../assets/gamification/rouletteFrameOff.png')
    useEffect(() => {
        const interval = setInterval(() => {
            setRouletteState((prevState) => !prevState)
        }, 500) // Cambiar cada 1 segundo

        return () => clearInterval(interval) // Limpiar el intervalo cuando el componente se desmonte
    }, [])

    return (
        <View
            style={{
                alignItems: 'center',
                justifyContent: 'center',
                transform: [
                    { rotate: `${-viewRotation}deg` }, // Rotate the image to point outward
                ],
            }}
        >
            <Pressable
                onPress={() => startSpinning()}
                style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}
            >
                <Svg width={size} height={size}>
                    <Defs>
                        {colors.map((segment, i) => (
                            <React.Fragment key={`grad-wrapper-${i}`}>
                                <LinearGradient
                                    key={`grad-${i}`}
                                    id={`grad-${i}`}
                                    gradientUnits='userSpaceOnUse'
                                    x1={
                                        center +
                                        radius *
                                            Math.cos(
                                                degToRad(
                                                    i * anglePerSegment +
                                                        GAP_ANGLE / 2,
                                                ),
                                            )
                                    }
                                    y1={
                                        center +
                                        radius *
                                            Math.sin(
                                                degToRad(
                                                    i * anglePerSegment +
                                                        GAP_ANGLE / 2,
                                                ),
                                            )
                                    }
                                    x2={center}
                                    y2={center}
                                >
                                    {/* Color centro ruleta */}
                                    <Stop
                                        offset='0%'
                                        stopColor={segment.last_color}
                                    />
                                    {/* Color medio ruleta */}
                                    <Stop
                                        offset='50%'
                                        stopColor={segment.middle_color}
                                    />
                                    {/* Color mas lejano ruleta */}
                                    <Stop
                                        offset='100%'
                                        stopColor={segment.first_color}
                                    />
                                </LinearGradient>
                                <LinearGradient
                                    key={`grad-border-${i}`}
                                    id={`grad-border-${i}`}
                                    gradientUnits='userSpaceOnUse'
                                    x1={
                                        center +
                                        radius *
                                            Math.cos(
                                                degToRad(
                                                    i * anglePerSegment +
                                                        GAP_ANGLE / 2,
                                                ),
                                            )
                                    }
                                    y1={
                                        center +
                                        radius *
                                            Math.sin(
                                                degToRad(
                                                    i * anglePerSegment +
                                                        GAP_ANGLE / 2,
                                                ),
                                            )
                                    }
                                    x2={center}
                                    y2={center}
                                >
                                    {/* Color centro ruleta */}
                                    <Stop
                                        offset='0%'
                                        stopColor={
                                            RouletteComponentTheme.centerStop0color
                                        }
                                    />
                                    <Stop
                                        offset='23%'
                                        stopColor={
                                            RouletteComponentTheme.centerStop23Color
                                        }
                                    />
                                    <Stop
                                        offset='43%'
                                        stopColor={
                                            RouletteComponentTheme.centerStop43Color
                                        }
                                    />
                                    <Stop
                                        offset='70%'
                                        stopColor={
                                            RouletteComponentTheme.centerStop70Color
                                        }
                                    />
                                    <Stop
                                        offset='100%'
                                        stopColor={
                                            RouletteComponentTheme.centerStop100Color
                                        }
                                    />
                                </LinearGradient>
                            </React.Fragment>
                        ))}
                    </Defs>

                    {segments.map((segment, i) => {
                        const startAngle = i * anglePerSegment + GAP_ANGLE / 2
                        const endAngle = startAngle + adjustedAngle

                        const path = describeDonutSlice(
                            center,
                            center,
                            radius,
                            innerRadius,
                            startAngle,
                            endAngle,
                        )
                        const isSelected = i === selectedIndex
                        return (
                            <G
                                key={i}
                                rotation={0}
                                originX={center}
                                originY={center}
                            >
                                <Path
                                    d={path}
                                    fill={`url(#grad-${i})`}
                                    stroke={
                                        isSelected
                                            ? `url(#grad-border-${i})`
                                            : 'transparent'
                                    }
                                    strokeWidth={isSelected ? 6 : 0}
                                />
                                {isSelected && (
                                    <Image
                                        source={require('../../../assets/gamification/knob.png')}
                                        style={{
                                            width: radius * 0.2, // Dynamic width based on the segment size
                                            height: radius * 0.2, // Keep aspect ratio
                                            position: 'absolute',
                                            left:
                                                center +
                                                radius *
                                                    0.3 *
                                                    Math.cos(
                                                        degToRad(
                                                            startAngle +
                                                                adjustedAngle / 2,
                                                        ),
                                                    ) -
                                                22.5, // Adjusted for better centering horizontally
                                            top:
                                                center +
                                                radius *
                                                    0.3 *
                                                    Math.sin(
                                                        degToRad(
                                                            startAngle +
                                                                adjustedAngle / 2,
                                                        ),
                                                    ) -
                                                22.5, // Adjusted for better centering vertically
                                            transform: [
                                                {
                                                    rotate: `${startAngle + adjustedAngle / 2 + 90}deg`,
                                                }, // Rotate the image to point outward
                                            ],
                                        }}
                                    />
                                )}
                                <Image
                                    source={{ uri: segment.image }}
                                    style={{
                                        width: 100,
                                        height: 100,
                                        position: 'absolute',
                                        left:
                                            center +
                                            radius *
                                                0.65 *
                                                Math.cos(
                                                    degToRad(
                                                        startAngle +
                                                            adjustedAngle / 2,
                                                    ),
                                                ) -
                                            50,
                                        top:
                                            center +
                                            radius *
                                                0.65 *
                                                Math.sin(
                                                    degToRad(
                                                        startAngle +
                                                            adjustedAngle / 2,
                                                    ),
                                                ) -
                                            50,
                                        transform: [
                                            {
                                                rotate: `${startAngle + adjustedAngle / 2 + 90}deg`,
                                            },
                                        ],
                                    }}
                                />
                            </G>
                        )
                    })}
                </Svg>
                <Image
                    source={rouletteState ? imageOn : imageOff}
                    style={{
                        width: size * 1.26,
                        height: size * 1.26,
                        position: 'absolute',
                    }}
                    resizeMode='cover'
                    resizeMethod='resize'
                />
                <View
                    style={{
                        width: 80,
                        height: 80,
                        position: 'absolute',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 40,
                        transform: [
                            { rotate: `${viewRotation}deg` }, // Rotate the image to point outward
                        ],
                    }}
                >
                    <Image
                        source={require('../../../assets/gamification/rouletteButton.png')}
                        style={{
                            width: 120,
                            height: 120,
                        }}
                    />
                </View>
                {selectedCategory && (
                    <ImageBackground
                        source={require('../../../assets/gamification/rouletteCategory.png')}
                        style={{
                            width: size / 0.83,
                            height: size / 0.83,
                            position: 'absolute',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transform: [
                                { rotate: `${viewRotation}deg` }, // Rotate the image to point outward
                            ],
                        }}
                        resizeMethod='resize'
                        resizeMode='cover'
                    >
                        <View
                            style={{ width: 200, height: 200, position: 'absolute' }}
                        >
                            <Image
                                source={{ uri: selectedCategory.image }}
                                style={{ width: 200, height: 180 }}
                            />
                            <Text
                                style={{
                                    zIndex: 2,
                                    color: 'white',
                                    fontSize: 25,
                                    fontWeight: '800',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    marginTop: 1,
                                    overflow: 'hidden',
                                    lineHeight: 32,
                                    marginBottom: 0,
                                }}
                                numberOfLines={4}
                            >
                                {selectedCategory.name}
                            </Text>
                        </View>
                    </ImageBackground>
                )}
            </Pressable>
        </View>
    )
}
